import {
    ua,
    qs,
    getDeepVal,
    miniNav
} from '@kkmh/utils'
import {
    getPayParam,
    getNativeInfo,
    setTrack,
} from "../../../assets/utils";
import {
    getH5Rechargegoods,
    getH5RechargegoodsBrowser,
} from "../../../assets/api";
import {
    // forward,
    switch_page,
    receive_page_status
} from '@kk/h5-sdk'
export const getBaseParam = (opt = {}) => {
    return new Promise(resolve => {
        getNativeInfo().then((nativeinfo) => {
            let param = {
                third_activity: opt.third_activity || (qs['third_activity'] || ''),
                non_iap_supported: opt.non_iap_supported || (qs['non_iap_supported'] || ''),//运营位是否支持越狱，1表示支持;
                topic_id: parseInt(opt.topic_id) || (parseInt(qs['topic_id']) || 0),
                comic_id: parseInt(opt.comic_id) || (parseInt(qs['comic_id']) || 0),
                comic_price: opt.comic_price || 0,         //不必须-int 需要购买漫画的价格(kkb半屏的title文案：余额不足请充值 or 请充值)
                origin: opt.trigger_page || '',
                trigger_page: opt.trigger_page || 'KK币半屏弹窗页', // TriggerPage字段 付费v10.0 需求
                from: ua.kkmh ? 1 : 5,      //投放载体，端内APP：1 M站：5
                good_type: 1,                    //必须-int 1.kkb 2.vip
                //端外支付回调地址
                redirect_url: opt.redirect_url || "",//不必须-string 支付成功之后想跳回的h5地址
                gender_type:opt.gender_type || "", //男女版
                topic_name:opt.topic_name || "", // 专题名称
                comic_name:opt.comic_name || "", // 漫画名称
                activity_name:opt.activity_name || "", // 活动名称
                activity_mark:opt.third_activity || (qs['third_activity'] || ''),// 活动标识-半屏弹窗中的活动唯一标识
                pre_page:opt.pre_page || "",// 上一页面
                popup_name:opt.popup_name || "充值KK币半屏",// 弹窗名称
                cur_page:opt.cur_page || "", // 当前页面
                puwid: opt.puwid || (qs['puwid'] || 0) // 弹窗id
            }
            if (ua.miniprogram) {
                param.cps = opt.cps || '';  // 支付成功时 支付结果埋点 cps  小程序时需要
                param.source_platform=opt.source_platform || "";// 小程序来源平台
                param.mini_program_version=opt.mini_program_version || "";// 小程序版本
                param.locate=opt.locate || "";// 小程序所需属性
                param.cps_parameter=opt.cps_parameter || "";// 小程序cps
            }
            //初始化埋点信息
            let track_id = nativeinfo.uid || nativeinfo.device_id;
            setTrack(track_id)

            resolve({
                ...getPayParam(opt),
                ...nativeinfo,
                ...param
            })
        });
    })
}
export const getKkbList = (opt) => {
    return new Promise(resolve => {
        if (ua.kkmh) {
            getH5Rechargegoods(opt).then((res) => {
                resolve(res);
            }).catch(error => {
                resolve(error);
            });
        } else {
            getH5RechargegoodsBrowser(opt).then((res) => {
                resolve(res);
            }).catch(error => {
                resolve(error);
            })
        }
    })
}
export const getKkbViewData = (opt) => {
    return new Promise(resolve => {
        if (ua.kkmh) {
            getH5Rechargegoods(opt).then((res) => {
                let { code, message, data = {} } = res || {};
                if (code !== 200) {
                    resolve({ code: -21011, message });
                    return null;
                }
                resolve({ code, data: getNativeViewData(data, opt), message });
            }).catch(error => {
                resolve({ code: -21012, data: {}, message: error });
            });
        } else {
            getH5RechargegoodsBrowser(opt).then((res) => {
                let { code, message, data = {} } = res || {};
                if (code !== 200) {
                    resolve({ code: -21021, message });
                    return null;
                }
                setTrack(getDeepVal(data, 'user.id', ''));
                resolve({ code, data: getBrowserViewData(data, opt), message });
            }).catch(error => {
                resolve({ code: -21022, data: {}, message: error });
            })
        }
    })
}

export const jumpToRechargeCenter = (opt, cb) => {
    if (ua.kkmh) {
        // forward({
        //     todata  : {
        //         fromPage    : opt.trigger_page,
        //         productId   : 0,
        //         showPayType : false 
        //     },
        //     totype: "native",
        //     topage: "mine/wallet/rechargecenter",
        //     callback : (res) => {//adr - 没有callback, 因而用监听协议来处理结果
        //     }
        // });
        switch_page({
            // actionTarget: {
            //     action_type : 22,
            //     target_tag : JSON.stringify({
            //         triggerPage : opt.trigger_page,
            //         topicId     : 0 
            //     })
            // },
            action_type: 22,
            extra_params: {
                target_tag: JSON.stringify({
                    triggerPage: opt.trigger_page,
                    topicId: 0
                })
            },
            progress_bar: 0,
            callback: (res) => {//callback, 双端都各式各样没法很好的做兼容处理，因而改用监听协议来处理结果
            }
        })

        receive_page_status({
            callback: (res, nativecallback_name) => {
                cb && cb(res, nativecallback_name);
            }
        })
    } else if (ua.miniprogram) {
        let base_url = location.href;
        // back_type:1-购买kkb,2-开通vip
        if (/\?/.test(base_url)) {
            base_url += "&back_type=1"
        } else {
            base_url += "?back_type=1"
        }

        let V_PARAM = getPayParam({
            ...opt,
            pay_source: 2,//2.小程序埋点-活动页(h5)
            redirect_url:encodeURIComponent(base_url)

        })

        let url = `/pages/buykkb/buykkb?redirect_url=${encodeURIComponent(base_url)}&v_param=${encodeURIComponent(JSON.stringify(V_PARAM))}&t=${new Date().getTime()}`;

        miniNav(url);
    } else {
        let V_PARAM = getPayParam({
            ...opt,
        })
        let url = location.protocol + '//' + location.host + '/webapp/pay/buykkb.html?';
        if (location.port) {
            url = location.protocol + '//' + location.hostname + ':8080/webapp/pay/buykkb.html?';
        }
        url = `${url}pay_info=${encodeURIComponent(JSON.stringify(V_PARAM))}`;
        if (!ua.prod) {
            url = `${url}&eruda=true`;
        }
        location.href = url;
    }
}
const getNativeViewData = (data, opt) => {
    let recharge = getDeepVal(data, 'recharges.0', {});
    let account = getDeepVal(data, 'user_account', {});
    let accumact = getDeepVal(data, 'accum_activity', {}); // 多充多送活动
    let user = getDeepVal(data, 'user', {});
    let is_login = !data.visitor;

    //1.档位
    let goods = recharge.recharge_goods || [];
    //2.我的KKB
    let mykkb = ua.iphone ? account.ios_balance : account.non_ios_balance;
    //3.半屏标题
    let title = getTitle(data, opt);
    //4.备注
    let mark = recharge.remark || '';
    //5.显示充值档位
    let show = recharge.show_all || false;
    //6.多充多送
    accumact.accum_level_list = accumact.accum_level_list || [];
    // 7.运营位
    let operate_info = getOperateInfo(recharge.words_info, recharge.image_info);


    let obj = {
        user,
        goods,
        mykkb,
        title,
        mark,
        show,
        accumact,
        operate_info,
        is_login,
    };
    return obj;
}
const getBrowserViewData = (data, opt) => {
    let recharge = getDeepVal(data, 'recharges.0', {});
    let user = getDeepVal(data, 'user', {});
    let account = getDeepVal(data, 'user_account', {});
    let accumact = getDeepVal(data, 'accum_activity', {}); // 多充多送活动
    let is_login = !data.visitor;


    //1.档位
    let goods = recharge.recharge_goods || [];
    //2.我的KKB
    let mykkb = ua.iphone ? account.ios_balance : account.non_ios_balance;
    //3.半屏标题
    let title = getTitle(data, opt);
    //4.备注
    let mark = recharge.remark || '';
    //5.显示充值档位
    let show = recharge.show_all || false;
    //6.多充多送
    accumact.accum_level_list = accumact.accum_level_list || [];
    accumact.accum_title_image = accumact.accum_title_image || "";
    accumact.accum_title_image = accumact.accum_title_image.replace(/-w\d+$/,"");
    // 7.运营位
    let operate_info = getOperateInfo(recharge.words_info, recharge.image_info);

    let obj = {
        user,
        goods,
        mykkb,
        title,
        mark,
        show,
        accumact,
        operate_info,
        is_login
    };
    return obj;
}

const getTitle = (data, opt) => {
    let title = getDeepVal(data, 'recharges.0.goods_title', '请充值');
    let ioskkb = getDeepVal(data, 'user_account.ios_balance', 0);
    let adrkkb = getDeepVal(data, 'user_account.non_ios_balance', 0);
    let mykkb = ua.iphone ? ioskkb : adrkkb;

    //1.请充值 2.余额不足请充值 3.活动标题后台配置
    if (mykkb < opt.comic_price) {
        title = '余额不足请充值';
    }
    return title;
}

const getOperateInfo = (words_info={}, image_info={}) => {
    let newObj = {};
    newObj.banner_title = words_info.banner_title || '';
    newObj.banner_sub_title = words_info.banner_sub_title || '';
    newObj.banner_image = image_info.banner_image || '';
    newObj.banner_image_right = image_info.banner_image_right || '';
    if(image_info.banner_image) {
        newObj.type = "image";
    } else if(image_info.banner_image_right&&words_info.banner_sub_title&&words_info.banner_title) {
        newObj.type = "image_text";
    } else {
        newObj.type = "";
    }
    return newObj;
}

export const jumpActivityDetails = (url, cb) => {
    if (url.indexOf('202202/accum_act_detail') > -1) {
        // 如果链接是跳转到透明弹窗页需要添加 origin: 判断不是充值中心 refresh: 小程序隐现强制刷新
        url = url.indexOf('?') > -1 ? `${url}&origin=true` : `${url}?origin=true`;
    }
    if (ua.kkmh) {
        switch_page({
            action_type: 18,
            extra_params: {
                target_web_url: url,
                hybrid_url: url
            },
            progress_bar: 0,
            callback: (res) => {}
        });
        receive_page_status({
            callback: (res, nativecallback_name) => {
                cb && cb(res, nativecallback_name);
            }
        })
    } else if(ua.miniprogram) {
        url = `/pages/webview/webview?type=2003&url=${encodeURIComponent(url+"")}`;
        cb && cb({});
        miniNav(url);
    } else {
        cb && cb({});
        window.location.href = url;
    }
}






// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/kkbhalfscreen/js/common.js